import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ConsoleDialogFrameProps extends Omit<DialogProps, 'title'> {
  title: React.ReactNode;
  icon?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const ConsoleDialogFrame: React.FC<ConsoleDialogFrameProps> = ({
  title,
  icon,
  subtitle,
  actions,
  children,
  ...dialogProps
}) => {
  return (
    <Dialog
      {...dialogProps}
      PaperProps={{
        ...(dialogProps.PaperProps || {}),
        sx: {
          borderRadius: 0,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          ...(dialogProps.PaperProps?.sx || {}),
        },
      }}
    >
      <DialogTitle
        sx={{
          px: 2,
          py: 1.4,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.default',
        }}
      >
        <Stack direction="row" justifyContent="space-between" spacing={1.2} alignItems="flex-start">
          <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
            {icon ? <Box sx={{ color: 'primary.main', display: 'inline-flex', alignItems: 'center' }}>{icon}</Box> : null}
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.68rem', fontWeight: 900, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'text.secondary', mb: 0.2 }}>
                Console Action
              </Typography>
              <Typography variant="h6" fontWeight={900} noWrap>
                {title}
              </Typography>
              {subtitle ? (
                <Typography sx={{ mt: 0.25, fontSize: '0.78rem', color: 'text.secondary' }}>
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
          </Stack>
          {dialogProps.onClose ? (
            <IconButton onClick={(event) => dialogProps.onClose?.(event, 'backdropClick')} sx={{ borderRadius: 0 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          ) : null}
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: 2, py: 2 }}>
        {children}
      </DialogContent>
      {actions ? (
        <DialogActions sx={{ px: 2, py: 1.5, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.default' }}>
          {actions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
